import { render, staticRenderFns } from "./TranslateText.vue?vue&type=template&id=b0607526&scoped=true"
import script from "./TranslateText.vue?vue&type=script&lang=js"
export * from "./TranslateText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0607526",
  null
  
)

export default component.exports